import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AirBookingDetailsComponent } from './air-booking-details.component';
import { BookingInformationModule } from 'libraries/component/booking-information/booking-information.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { BreadcrumbModule } from 'libraries/component/breadcrumb/breadcrumb.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { ExternalRedirectionService } from '../../service/external-redirection.service';
import { PermissionModule } from 'libraries/permission/permission.module';
import { BreadcrumbIqbaModule } from 'app_locobook/service/breadcrumbIqba/breadcrumbIqba.module';
import { AirBookingResourceModule } from "libraries/service/resources/air-booking/air-booking-resource.module";
import {
    GetChangedPriceWarningPipe
} from "app_locobook/pages/air-booking-details/get-changed-price-warning.pipe";
import { PriceModule } from "libraries/component/price/price.module";

@NgModule({
    imports: [
        AirBookingResourceModule,
        CommonModule,
        BookingInformationModule,
        BreadcrumbModule,
        NotificationModule,
        LoaderModule,
        CardModule,
        BtnModule,
        PermissionModule,
        BreadcrumbIqbaModule,
        PriceModule,
    ],
    exports: [],
    declarations: [
        AirBookingDetailsComponent,
        GetChangedPriceWarningPipe,
    ],
    providers: [
        ExternalRedirectionService,
        GetChangedPriceWarningPipe,
    ],
})
export class AirBookingDetailsModule {
}
